<div class="export-account-wrapper">
  @if (currentStep() === "password") {
    <div
      class="export-account__password-step flex column gap-24 align-items-center"
    >
      <div class="flex column gap-8 text-align-center">
        <span class="typo-title-3">Confirm Password</span>
        <span class="typo-text-2 text-medium">
          Enter your wallet password to reveal this account's private key.
        </span>
      </div>
      <div class="export-account__password-form flex column gap-16">
        <kc-input
          [infoLabel]="{ label: 'Password' }"
          [type]="'password'"
          [placeholder]="'Enter your password'"
          [isValid]="!passwordError()"
          [(ngModel)]="password"
          (ngModelChange)="onPasswordInput()"
          (keyup.enter)="onVerifyPassword()"
        />
        @if (passwordError()) {
          <span class="kc-input-error-text">{{ passwordError() }}</span>
        }
        <kc-button
          [text]="'Continue'"
          [variant]="'primary'"
          [isDisabled]="isVerifying() || !password().trim()"
          (buttonClick)="onVerifyPassword()"
        />
      </div>
    </div>
  } @else {
    @if (!loadError()) {
      <div class="export-account">
        <div class="export-account__warning">
          <span class="typo-text-2">
            Keep your private key secure. Anyone with this key can control this
            account.
          </span>
        </div>

        <div class="export-account__meta">
          <div class="export-account__row">
            <span class="export-account__label">Wallet</span>
            <span class="export-account__value">{{ walletName() }}</span>
          </div>
          @if (accountName()) {
            <div class="export-account__row">
              <span class="export-account__label">Account</span>
              <span class="export-account__value">{{ accountName() }}</span>
            </div>
          }
          @if (derivedPath()) {
            <div class="export-account__row">
              <span class="export-account__label">Derived path</span>
              <span class="export-account__value">{{ derivedPath() }}</span>
            </div>
          }
        </div>

        <div class="export-account__key">
          <code>{{ privateKey() }}</code>
        </div>

        <div class="export-account__actions">
          <kc-button
            [text]="'Copy'"
            [variant]="'secondary'"
            [suffixIcon]="'icon-copy'"
            [isDisabled]="!privateKey()"
            (buttonClick)="copyPrivateKey()"
          />
          <kc-button
            [text]="'Download .txt'"
            [variant]="'primary'"
            [suffixIcon]="'icon-download'"
            [isDisabled]="!privateKey()"
            (buttonClick)="downloadPrivateKey()"
          />
        </div>
      </div>
    } @else {
      <div class="export-account__error">
        <span class="typo-text-2"
          >Unable to load this account's private key.</span
        >
        <kc-button
          [text]="'Back'"
          [variant]="'secondary'"
          (buttonClick)="navigateBackToPrevious()"
        />
      </div>
    }
  }
</div>
